var _desc, _defs, _rect, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _circle5, _rect4, _rect5, _rect6, _rect7, _rect8, _text, _rect9, _rect10, _rect11, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _rect12, _text9, _text10, _rect13, _text11, _text12, _text13, _g, _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _polygon4, _rect14, _text14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullstack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fullstack Development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "UI and backend integration scene showing application flow from frontend to API and server logic.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0e3756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "58%",
    stopColor: "#08253c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#051728"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#123f61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d2f49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "api",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffe07a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffd700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "flow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ed2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffd700"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    rx: 18,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 58,
    r: 120,
    fill: "#5ec7ff",
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 302,
    r: 146,
    fill: "#ffd700",
    opacity: 0.06
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 236,
    height: 248,
    rx: 14,
    fill: "url(#card)",
    stroke: "#2d739f",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 236,
    height: 28,
    rx: 14,
    fill: "#15527e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 70,
    r: 4,
    fill: "#ffd700"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 70,
    r: 4,
    fill: "#83d4ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 70,
    r: 4,
    fill: "#79d7b1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 100,
    width: 196,
    height: 22,
    rx: 6,
    fill: "#1d5f8b"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 132,
    width: 112,
    height: 72,
    rx: 8,
    fill: "#194b70"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 132,
    width: 74,
    height: 72,
    rx: 8,
    fill: "#1a537d"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 216,
    width: 196,
    height: 16,
    rx: 8,
    fill: "#2d83bb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 240,
    width: 132,
    height: 16,
    rx: 8,
    fill: "#1b567f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 286,
    fill: "#9fd8ff",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    letterSpacing: 1
  }, "UI")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 56,
    width: 236,
    height: 248,
    rx: 14,
    fill: "url(#card)",
    stroke: "#2d739f",
    strokeWidth: 1.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 56,
    width: 236,
    height: 28,
    rx: 14,
    fill: "#134a72"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 94,
    width: 204,
    height: 128,
    rx: 10,
    fill: "#0d334d",
    stroke: "#2a6f99"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 112,
    fill: "#ffd700",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "@Bean")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 126,
    fill: "#9fd8ff",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "RouterFunction&lt;ServerResponse&gt; routes() {")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 140,
    fill: "#8be3bc",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "return route(GET(\"/api/deliberation\"),")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 154,
    fill: "#9fd8ff",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "request -&gt; service.findById(request.pathVariable(\"id\"))")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 168,
    fill: "#9fd8ff",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, ".flatMap(result -&gt; ok().bodyValue(result))")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 394,
    y: 182,
    fill: "#9fd8ff",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, ".switchIfEmpty(notFound().build()));")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 388,
    y: 196,
    fill: "#9fd8ff",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "}")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 378,
    y: 228,
    width: 126,
    height: 44,
    rx: 10,
    fill: "#1a5f8f"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 247,
    fill: "#fff0ad",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "WebFlux")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 260,
    fill: "#b7e4ff",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "non-blocking I/O")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 228,
    width: 70,
    height: 44,
    rx: 10,
    fill: "#0f3f5e"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 523,
    y: 247,
    fill: "#fff0ad",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "R2DBC")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 523,
    y: 260,
    fill: "#b7e4ff",
    fontFamily: "Courier New, monospace",
    fontSize: 9
  }, "DB")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 382,
    y: 286,
    fill: "#b7e4ff",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    letterSpacing: 1
  }, "BACKEND LOGIC")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softGlow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 178,
    r: 44,
    fill: "#0b3654",
    stroke: "#ffd700",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 178,
    r: 34,
    fill: "#124d74"
  }), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 173,
    fill: "#fff3bf",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    textAnchor: "middle",
    letterSpacing: 1.3
  }, "API"), /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 189,
    fill: "#9ad8ff",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    textAnchor: "middle"
  }, "integration"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276 178h42",
    stroke: "url(#flow)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322 138v-30",
    stroke: "url(#flow)",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364 178h-42",
    stroke: "url(#flow)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M322 248v-30",
    stroke: "url(#flow)",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "313,146 322,132 331,146",
    fill: "url(#api)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "313,210 322,224 331,210",
    fill: "url(#api)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "286,170 272,178 286,186",
    fill: "#88d2ff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "354,170 368,178 354,186",
    fill: "#ffd700"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 300,
    width: 104,
    height: 20,
    rx: 10,
    fill: "#0c3552",
    stroke: "#2f7cae"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 314,
    fill: "#bde7ff",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    textAnchor: "middle",
    letterSpacing: 1.1
  }, "FRONT - API - BACK")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullstack);
export default __webpack_public_path__ + "static/media/fullstack.ff00e9779407f43e770837d9e4b43122.svg";
export { ForwardRef as ReactComponent };